(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-chart"] && !Shopify.designMode) return;
  try {
    (function () {
    const sizeGuide = document.getElementById('SizeGuide');
    if (!sizeGuide) return;

    const openBtn = sizeGuide.querySelector('.js-size-guide-trigger');
    const closeBtns = sizeGuide.querySelectorAll('.js-size-guide-close');
    const modal = sizeGuide.querySelector('.size-guide__modal');

    openBtn.addEventListener('click', () => {
      sizeGuide.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', closeSizeGuide);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSizeGuide();
    });

    function closeSizeGuide() {
      sizeGuide.classList.remove('active');
      document.body.style.overflow = '';
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
